import { Flex, Segmented, Spin, Typography } from "antd"
import cls from "classname"
import { Line } from "react-chartjs-2"
import { useTranslation } from "react-i18next"

import Icon from "../../../Icon"

import styles from "../styles.module.less"

const { Text } = Typography

const HomeChartCard = ({
  icon,
  title,
  segments,
  activeSegment,
  onSegmentChange,
  data,
  options,
  plugins,
  loading,
  banner,
  extra,
  footer,
  filterDisabled = false,
  testId
}) => {
  const { t } = useTranslation()

  return (
    <div className={styles.card} data-testid={testId}>
      <Flex align="center" justify="space-between" gap={16} className={styles.cardHeader}>
        <Flex align="center" gap={8}>
          <Icon type={icon} className={styles.cardHeaderIcon} />
          <Text strong className={styles.cardTitle}>
            {t(title)}
          </Text>
        </Flex>
        <Flex align="center" gap={12}>
          <Segmented
            disabled={filterDisabled}
            value={activeSegment}
            onChange={onSegmentChange}
            options={segments.map(({ value, label }) => ({ value, label: t(label) }))}
          />
          {extra}
        </Flex>
      </Flex>
      <Spin spinning={loading}>
        <div className={styles.chartArea}>
          <Line data={data} options={options} plugins={plugins} />
          {banner}
        </div>
      </Spin>
      <div className={cls(styles.cardFooter, { [styles.cardFooterOpen]: Boolean(footer) })}>
        <div>{footer}</div>
      </div>
    </div>
  )
}

export default HomeChartCard
